import React, { useState } from 'react';
import { MapPin, Edit3, Check, X } from 'lucide-react';

interface LocationSearchProps {
  location: string;
  onLocationChange: (location: string) => void;
}

export const LocationSearch: React.FC<LocationSearchProps> = ({ location, onLocationChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempLocation, setTempLocation] = useState(location);

  const handleSubmit = () => {
    onLocationChange(tempLocation);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setTempLocation(location);
    setIsEditing(false);
  };

  return (
    <div className="flex items-center justify-center">
      <div className="relative inline-flex items-center bg-white/40 backdrop-blur-sm rounded-2xl border border-white/30 p-4 hover:bg-white/60 transition-all duration-300 group">
        {isEditing ? (
          <form 
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            className="flex items-center space-x-3"
          >
            <input
              type="text"
              value={tempLocation}
              onChange={(e) => setTempLocation(e.target.value)}
              className="text-xl font-semibold bg-transparent border-b-2 border-pink-300 focus:border-pink-500 focus:outline-none text-center min-w-[250px] bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent placeholder-gray-400"
              autoFocus
              placeholder="Enter location..."
            />
            <div className="flex items-center space-x-2">
              <button
                type="submit"
                className="p-2 bg-gradient-to-r from-green-500/20 to-emerald-500/20 hover:from-green-500/30 hover:to-emerald-500/30 rounded-lg transition-all duration-200 group"
              >
                <Check className="w-4 h-4 text-green-600 group-hover:scale-110 transition-transform" />
              </button>
              <button
                type="button"
                onClick={handleCancel}
                className="p-2 bg-gradient-to-r from-red-500/20 to-pink-500/20 hover:from-red-500/30 hover:to-pink-500/30 rounded-lg transition-all duration-200 group"
              >
                <X className="w-4 h-4 text-red-600 group-hover:scale-110 transition-transform" />
              </button>
            </div>
          </form>
        ) : (
          <>
            <h2 className="text-xl font-semibold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent min-w-[200px] text-center">
              {location}
            </h2>
            <button
              onClick={() => setIsEditing(true)}
              className="ml-4 p-2 bg-gradient-to-r from-pink-500/20 to-orange-500/20 hover:from-pink-500/30 hover:to-orange-500/30 rounded-lg transition-all duration-200 opacity-60 group-hover:opacity-100 hover:scale-110"
            >
              <Edit3 className="w-4 h-4 text-pink-600" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};